<template>
	<v-footer padless app>
		<!-- donor's info -->
		<v-row class="mx-12 my-1" no-gutters>
			<v-col cols="12" md="2" sm="4" xs="4" align-self="center">
				<v-img :src="require('@/assets/tekwill.png')" 
					contain
					max-width="110">
				</v-img>
			</v-col>
			<v-col cols="12" md="2" sm="4" xs="4" align-self="center">
				<v-img
					:src="require('@/assets/USAID-Horizontal_small.png')" 
					contain max-width="110">
				</v-img>
			</v-col>
			<v-col cols="12" md="2" sm="4" xs="4" align-self="center" class="pt-2">
				<v-img
					:src="require(`@/assets/sweden_${locale.split('-')[0]}.png`)"
					:lazy-src="require(`@/assets/sweden_${locale.split('-')[0]}.png`)"
					contain 
					max-width="120">
					<template v-slot:placeholder>
						<v-row class="fill-height ma-0" justify="center">
							<v-progress-circular indeterminate color="secondary"></v-progress-circular>
						</v-row>
					</template>
				</v-img>
			</v-col>
			<v-col cols="12" md="6" sm="12" class="caption text-justify" align-self="center">
				<strong>
					{{ 'footer text' | localize }}
				</strong>
			</v-col>
		</v-row>
		<!-- footer -->
		<v-card tile color="primary" class="white--text caption text-center" width="100%">
			<v-row class="my-2 mx-8" 
				align-content="center"
				justify="center" 
				no-gutters>
				<v-col align-self="center">
					<a href="#">{{ 'Terms and Conditions' | localize }}</a> | <a href="#">{{ 'Privacy Policy' | localize }}</a>
				</v-col>
				<v-col align-self="center">
					{{ 'Copyright'| localize }} &copy; Datalinie business inginerie {{ new Date().getFullYear() }}
				</v-col>
				<!--social buttons-->
				<v-col class="text-center" align-self="center">
					{{'follow us' | localize }}:
					<v-btn icon color="white"
						class="mx-4"
						target="_blank"
						href="https://www.facebook.com/smartBusinessLearning">
						<v-icon>mdi-facebook</v-icon>
					</v-btn>
					<v-btn icon color="white" class="ml-2">
						<v-icon>mdi-whatsapp</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</v-card>
	</v-footer>
</template>
<script>
export default {
	data() {
		return {}
	},
	computed: {
		loading() {
			return this.$store.getters.loading
		},
		locale() {
			console.log(this.$store.getters.locale)
			return this.$store.getters.locale;
		},
	}
}

</script>
<style scoped>
	.small-text {
		font-size: 0.8em;
		letter-spacing: 1px;
	}
	a, a:visited, a:link {
		color: #fff;
		text-decoration: none;
	}
</style>